import script from "./AboutUs.vue?vue&type=script&setup=true&lang=ts"
export * from "./AboutUs.vue?vue&type=script&setup=true&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=48f2e3e1&scoped=true&lang=css"
import "./AboutUs.vue?vue&type=style&index=1&id=48f2e3e1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48f2e3e1"]])

export default __exports__